var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.formReady ? _c('div', {
    staticClass: "flex-row chemtracker-module",
    attrs: {
      "id": "add-chemical-container-inventory"
    }
  }, [_c('b-modal', {
    ref: "chemSearchUnlinked",
    attrs: {
      "size": "md",
      "hide-backdrop": "",
      "centered": "",
      "hide-footer": "",
      "cancel-disabled": "",
      "ok-disabled": "",
      "id": "chem-search-unlinked",
      "title": _vm.unlinkedModalTitle
    },
    on: {
      "close": function ($event) {
        return _vm.cancelAddUnlinkedChemical({
          reason: 'cancel'
        });
      }
    }
  }, [_c('div', {
    staticClass: "d-block text-center",
    attrs: {
      "id": "chem-search-form"
    }
  }, [_c('unlinked-chemical-form', {
    attrs: {
      "search-term": _vm.chemSearchValue
    },
    on: {
      "unlinked-constituent-added": _vm.handleUnlinkedSelection,
      "cancel-add-unlinked-chemical": _vm.cancelAddUnlinkedChemical,
      "change-modal-title": function (value) {
        return _vm.unlinkedModalTitle = value;
      }
    }
  })], 1)]), _vm._v(" "), _vm.chemSnapEnabled ? _c('b-modal', {
    ref: "chemSnapUi",
    attrs: {
      "centered": "",
      "hide-footer": "",
      "cancel-disabled": "",
      "ok-disabled": "",
      "no-close-on-backdrop": "",
      "hide-header": ""
    },
    on: {
      "close": _vm.closeChemSnapModal
    }
  }, [_c('ChemSnapUpload', {
    ref: "chemSnapUpload",
    attrs: {
      "chem-snap-config": _vm.chemSnapConfig
    },
    on: {
      "close-modal": _vm.closeChemSnapModal,
      "upload-success": _vm.handleChemSnapData
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitEntity.apply(null, arguments);
      }
    }
  }, [_c('v-teleport', {
    attrs: {
      "to": "#page-title"
    }
  }, [_c('div', {
    staticClass: "header-buttons"
  }, [_c('div', [_vm.chemSnapEnabled ? _c('v-button', {
    staticClass: "ghost primary xsmall",
    attrs: {
      "id": "chemsnap-scan-with-camera",
      "type": "button"
    },
    on: {
      "click": _vm.showChemSnapModal
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.AiIconSrc,
      "alt": "chemSnap icon"
    }
  }), _vm._v("Add with Camera\n          ")]) : _vm._e()], 1), _vm._v(" "), _vm.showDromoButton ? _c('DromoImportButton', {
    attrs: {
      "is-ghost-button": true
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _vm._l(_vm.fields, function (fieldData) {
    var _fieldData$form_displ, _vm$formData;
    return _c('div', {
      key: 'fields-' + (fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name)
    }, [(fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name) === 'field_chemical_type' ? _c('chemical-search', {
      ref: "chemAddInvSearch",
      refInFor: true,
      attrs: {
        "field-config": fieldData,
        "required": true,
        "allow-delete": true,
        "options-above": true,
        "options-inline": true,
        "chemical-search-type-default": _vm.chemSearchDefaultType,
        "default-lookup-value": _vm.chemSearchValue,
        "local-chemical": _vm.chemSearchOverride,
        "value": _vm.formData.field_chemical_type,
        "is-chemsnap-enabled": _vm.chemSnapEnabled,
        "chem-snap-data": _vm.chemSnapData,
        "horizontal-options": true,
        "show-search-input": _vm.showSearchInput[fieldData.field_name]
      },
      on: {
        "chemical-lookup-clear": function ($event) {
          _vm.chemSearchOverride = {};
          _vm.formData.field_chemical_type = {};
        },
        "chemical-lookup-selection": function (value) {
          return _vm.handleChemicalLookupSelection(value);
        },
        "toggle-show-search-input": function () {
          return _vm.toggleShowSearchInput(fieldData.field_name);
        },
        "search-unlinked-chemicals": _vm.searchUnlinkedChemicals
      }
    }) : _vm._e(), _vm._v(" "), !_vm.skipField(fieldData) && !_vm.fieldInDetails(fieldData) && (fieldData === null || fieldData === void 0 ? void 0 : (_fieldData$form_displ = fieldData.form_display) === null || _fieldData$form_displ === void 0 ? void 0 : _fieldData$form_displ.weight) <= _vm.additionalDetailWeight ? _c('entity-form-field', {
      key: fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name,
      ref: fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name,
      refInFor: true,
      attrs: {
        "field-data": fieldData,
        "parent-value": _vm.formData[fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name],
        "entity-type": "raft_metadata",
        "bundle": "chemical_container",
        "placeholder": _vm.getPlaceholder(fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name),
        "disabled": _vm.fieldDisabled(fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name),
        "add-class": _vm.addClass,
        "autocomplete-formatter": fieldData === null || fieldData === void 0 ? void 0 : fieldData.autocompleteFormatter
      },
      on: {
        "form-error-message": _vm.catchFormError,
        "update-form-data": _vm.updateFormData,
        "validation-error": _vm.handleValidationError
      }
    }) : _vm._e(), _vm._v(" "), (fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name) === 'og_audience' && !_vm.ogAudienceHidden ? _c('raft-autocomplete', {
      key: fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name,
      ref: "groupAutocomplete",
      refInFor: true,
      attrs: {
        "field-class": "entity-reference-field raft-og-audience",
        "id": fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name,
        "default-value": (_vm$formData = _vm.formData) === null || _vm$formData === void 0 ? void 0 : _vm$formData.og_audience,
        "name": fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name,
        "label": fieldData === null || fieldData === void 0 ? void 0 : fieldData.label,
        "element-id": "raft-group-autocomplete",
        "results-display": _vm.formatGroupResultsDisplay,
        "results-property": "title",
        "results-value": "uuid",
        "input-class": "form-control",
        "show-label": true,
        "disabled": _vm.fieldDisabled(fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name),
        "source": _vm.groupAutoCompleteResults,
        "field-required": true
      },
      on: {
        "selected": function (value) {
          return _vm.updateFormData(value, 'og_audience');
        },
        "clear": function ($event) {
          return _vm.updateFormData({}, 'og_audience');
        }
      }
    }) : _vm._e(), _vm._v(" "), (fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name) === 'field_chemical_space' ? _c('single-select-filter', {
      key: fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name,
      ref: "field_chemical_space",
      refInFor: true,
      staticClass: "chem-add-inventory-location-field",
      attrs: {
        "get-value": _vm.buildingSpaces,
        "id": "owning-group-fil",
        "data-test": "owning-group-filter",
        "multiple": false,
        "label": "Location (Space):",
        "display-value": "title",
        "disable": _vm.spaceFilterDisabled,
        "track-by": "uuid",
        "selected-items": _vm.formData['field_chemical_space'],
        "update-method": function (value) {
          return _vm.updateFormData(value, 'field_chemical_space');
        }
      }
    }) : _vm._e(), _vm._v(" "), (fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name) === 'field_chemical_container_id' ? _c('div', {
      attrs: {
        "id": "unique-container-id"
      }
    }, [_c('entity-form-field', {
      key: fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name,
      ref: fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name,
      refInFor: true,
      attrs: {
        "field-data": fieldData,
        "parent-value": _vm.formData[fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name],
        "entity-type": "raft_metadata",
        "bundle": "chemical_container",
        "placeholder": _vm.getPlaceholder(fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name),
        "disabled": _vm.fieldDisabled(fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name),
        "add-class": _vm.addClass,
        "autocomplete-formatter": fieldData === null || fieldData === void 0 ? void 0 : fieldData.autocompleteFormatter,
        "invalid": _vm.invalidInputError
      },
      on: {
        "form-error-message": _vm.catchFormError,
        "update-form-data": _vm.updateFormData,
        "validation-error": _vm.handleValidationError
      }
    })], 1) : _vm._e()], 1);
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "vlabel raftjs-hovertip",
    attrs: {
      "for": "chem-container-count"
    }
  }, [_vm._v("\n        Container Count:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "raftjs-hovertip-icon"
  }, [_vm._v("\n         \n        "), _c('b-img', {
    staticStyle: {
      "height": "0.75rem",
      "padding-left": "0.5rem"
    },
    attrs: {
      "id": "chem-container-count-hover",
      "src": _vm.helpSrc,
      "alt": "help"
    }
  }), _vm._v(" "), _c('b-popover', {
    attrs: {
      "target": "chem-container-count-hover",
      "triggers": "hover focus"
    }
  }, [_vm._v("\n          Indicate the number of containers to add. If a Unique ID number is\n          provided, the containers will be created with sequential unique ID\n          numbers.\n        ")])], 1)]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.containerCount,
      expression: "containerCount"
    }],
    ref: "chem-container-count-inp",
    attrs: {
      "type": "number",
      "id": "chem-container-count",
      "title": "null",
      "name": "Container Count",
      "data-test": "Container Count",
      "required": true,
      "max": 50,
      "min": 1,
      "step": 1
    },
    domProps: {
      "value": _vm.containerCount
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.containerCount = $event.target.value;
      }, function ($event) {
        return _vm.updateFormData('container-count');
      }]
    }
  }), _vm._v(" "), _c('details-field-group', {
    attrs: {
      "collapsed": !_vm.chemSnapFoundAdditionalDetails,
      "id": "additional_details_collapse",
      "label": "Additional Details"
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return _vm._l(_vm.fields, function (fieldData) {
          return _c('div', {
            key: 'details-fields-' + (fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name)
          }, [(fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name) === 'field_chemical_container_owner' ? _c('single-select-filter', {
            key: fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name,
            ref: "field_chemical_container_owner",
            refInFor: true,
            staticClass: "chem-add-inventory-chem-owner-field",
            attrs: {
              "get-value": _vm.chemUsers,
              "id": "owner-fil",
              "data-test": "owner-filter",
              "multiple": false,
              "disable-empty-selection": false,
              "label": "Chemical Owner:",
              "disabled": _vm.fieldDisabled('field_chemical_container_owner'),
              "track-by": "uuid",
              "selected-items": _vm.formData['field_chemical_container_owner'],
              "update-method": function (value) {
                return _vm.updateFormData(value, 'field_chemical_container_owner');
              }
            }
          }) : _vm._e(), _vm._v(" "), !_vm.skipField(fieldData) && _vm.fieldInDetails(fieldData) ? _c('entity-form-field', {
            ref: fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name,
            refInFor: true,
            attrs: {
              "field-data": fieldData,
              "no-default-value": _vm.noDefaultValueField(fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name),
              "parent-value": _vm.formData[fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name],
              "entity-type": "node",
              "bundle": "chemical_container",
              "placeholder": _vm.getPlaceholder(fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name),
              "disabled": _vm.fieldDisabled(fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name),
              "add-class": _vm.addClassAdditional
            },
            on: {
              "form-error-message": _vm.catchFormError,
              "update-form-data": _vm.updateFormData
            }
          }) : _vm._e()], 1);
        });
      },
      proxy: true
    }], null, false, 2444963536)
  }), _vm._v(" "), _vm._l(_vm.fields, function (fieldData) {
    var _fieldData$form_displ2;
    return _c('div', {
      key: fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name
    }, [!_vm.skipField(fieldData) && !_vm.fieldInDetails(fieldData) && (fieldData === null || fieldData === void 0 ? void 0 : (_fieldData$form_displ2 = fieldData.form_display) === null || _fieldData$form_displ2 === void 0 ? void 0 : _fieldData$form_displ2.weight) >= _vm.additionalDetailWeight ? _c('entity-form-field', {
      attrs: {
        "field-data": fieldData,
        "parent-value": _vm.formData[fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name],
        "entity-type": "node",
        "bundle": "chemical_container",
        "placeholder": _vm.getPlaceholder(fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name),
        "disabled": _vm.fieldDisabled(fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name),
        "add-class": _vm.addClass,
        "hidden": _vm.isConditionallyHidden(fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name)
      },
      on: {
        "form-error-message": _vm.catchFormError,
        "update-form-data": _vm.updateFormData
      }
    }) : _vm._e(), _vm._v(" "), (fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name) === 'field_chemical_dea_controlled' ? _c('b-form-checkbox', {
      attrs: {
        "name": 'checkbox-' + (fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name),
        "id": fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name
      },
      on: {
        "change": function (value) {
          return _vm.updateFormData(value, 'field_chemical_dea_controlled');
        }
      },
      model: {
        value: _vm.formData[fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name],
        callback: function ($$v) {
          _vm.$set(_vm.formData, fieldData === null || fieldData === void 0 ? void 0 : fieldData.field_name, $$v);
        },
        expression: "formData[fieldData?.field_name]"
      }
    }, [_vm._v(_vm._s(fieldData.label) + "?\n      ")]) : _vm._e()], 1);
  }), _vm._v(" "), _c('div', {
    staticClass: "add-inventory-button-row"
  }, [_vm.adding ? [_c('v-button', {
    class: _vm.buttonClasses('primary'),
    attrs: {
      "disabled": _vm.submitDisabled,
      "type": "submit"
    }
  }, [_vm._v("\n          Create\n        ")]), _vm._v(" "), _c('v-button', {
    class: _vm.buttonClasses('ghost primary'),
    attrs: {
      "disabled": _vm.submitDisabled,
      "data-test": "add-another",
      "enable-prevent": true
    },
    on: {
      "click": _vm.addAnother
    }
  }, [_vm._v("\n          Create and Add Another\n        ")])] : [_c('v-button', {
    class: _vm.buttonClasses('primary'),
    attrs: {
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.patchEntity();
      }
    }
  }, [_vm._v("\n          Update\n        ")])]], 2)], 2), _vm._v(" "), _c('recent-containers', {
    key: _vm.recentContainerIdKey,
    attrs: {
      "context-nid": _vm.contextNid
    }
  })], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }